import React from 'react';
import PropTypes from 'prop-types';

import useWorkflowGuard from 'hooks/useWorkflowGuard';

const PhoneVerificationPage = ({ navigate, searchParams }) => {
  useWorkflowGuard(searchParams, navigate);

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <div className="flex flex-col gap-6 text-sm md:text-base text-slate-600 px-0 md:px-[90px] mt-4">
        <p className="leading-[1.6]">Thank you for confirming your micro-deposit. Let&apos;s finalize the process and get your collateral back.</p>
        <p className="leading-[1.6]">
          A representative from our
          {' '}
          <span className="font-semibold">Verification Department</span>
          {' '}
          will be calling the phone number associated with your account to complete the phone verification step.
        </p>
      </div>
    </div>
  );
};

PhoneVerificationPage.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default PhoneVerificationPage;
